export default __webpack_public_path__ + "static/media/book.9b9a0588.svg";